export const priceAmountCents = (euros: number) => Math.round(euros * 100)

export interface KitsFilterState {
  categorySlug: string | null
  saleOnly: boolean
  priceMinEur: number | undefined
  priceMaxEur: number | undefined
}

/** Typesense `filter_by` equivalent of the Algolia facetFilters/filters built
 * in useKitsBrowseProducts.ts. Assumes the products_<locale> Typesense
 * collection mirrors Algolia's field names (categories.slug, has_promotions,
 * default_price.amount) with nested-field filtering enabled — verify against
 * the live collection schema before flipping kits traffic onto Typesense. */
export const buildKitsTypesenseFilterBy = ({
  categorySlug,
  saleOnly,
  priceMinEur,
  priceMaxEur,
}: KitsFilterState): string | undefined => {
  const clauses: string[] = []
  if (categorySlug) {
    clauses.push(`categories.slug:=${categorySlug}`)
  }
  if (saleOnly) {
    clauses.push('has_promotions:=true')
  }
  if (priceMinEur != null) {
    clauses.push(`default_price.amount:>=${priceAmountCents(priceMinEur)}`)
  }
  if (priceMaxEur != null) {
    clauses.push(`default_price.amount:<=${priceAmountCents(priceMaxEur)}`)
  }
  if (clauses.length === 0) return undefined
  return clauses.join(' && ')
}
